<form (submit)="submit()">
    <div class="sopo-popup-inner-container">   
        <span class="sopo-popup-title">Forgot Password</span>
        <div class="sopo-popup-input-container">
            <input
                class="sopo-popup-input"
                type="email"
                placeholder="Enter Email"
                [formControl]="forgotPasswordEmail"
            />
        </div>
        <ng-container *ngFor="let validation of validationMessages.email">
            <div class="ion-text-center error"
                *ngIf="forgotPasswordEmail.hasError(validation.type) && forgotPasswordEmail.dirty && errorFlag">
                {{ validation.message }}
            </div>
        </ng-container>
        <div class="sopo-popup-button-container">
            <ion-button
                class="sopo-popup-green-button"
                type="submit"
                shape="round"
                expand="full"
            >
                <span>Reset</span>
            </ion-button>
            <ion-button
                class="sopo-popup-red-button"
                shape="round"
                expand="full"
                (click)="dismiss()"
            >
                <span>Cancel</span>
            </ion-button>
        </div>
    </div>
</form>
